(function () {
	const slideshow = () => {
		document.querySelectorAll(".slideshow").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);
			const autoplay = block.data("autoplay");
			const stopAutoplay = block.data("stop-autoplay");
			const delay = block.data("delay") * 1000;
			const speed = block.data("speed") * 1000;
			const effect = block.data("effect");			
	
			let swiperParams = {
				speed: speed,
				keyboard: true,
				loop: true
			};
	
			let autoplayParams = autoplay ? {
				autoplay: {
					delay: delay,
					disableOnInteraction: false,
					pauseOnMouseEnter: stopAutoplay,
				},
			} : {};

			let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
			let swiperTextElement = document.querySelector(swiperTextSelector);
	
			const swiperText = new Swiper(swiperTextSelector, {
				...swiperParams,
				//autoplay: false,
				spaceBetween: 24,
				direction: "horizontal",
				slidesPerView: "auto",
				//slideToClickedSlide: true,
				//loopedSlides: 4,
				allowTouchMove: false,

				breakpoints: {
					990: {
						allowTouchMove: true,
					},
					1600: {
						allowTouchMove: false,
						touchRatio: 0,
						keyboard: {
							enabled: false,
						},
					},
				},
				on: {
					init: function () {
						swiperTextElement.classList.add('first_step');
					},
					slideChange: function () {
						swiperTextElement.classList.remove('first_step');
					}
				}
			});

			let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
			let swiperImgElement = document.querySelector(swiperImgSelector);

			const syncTabColors = (swiper) => {
				const activeSlide = swiper.slides[swiper.activeIndex];
				if (!activeSlide) return;
				const scheme = activeSlide.dataset.colorScheme;
				if (!scheme) return;

				swiperTextElement.querySelectorAll('.slideshow__tab').forEach((tab) => {
					tab.className = tab.className.replace(/\bcolor-\S+/g, '').trim();
					tab.classList.add(`color-${scheme}`);
				});
			};

			// While the header is in its transparent "overlay" state (class
			// color-background-2, toggled by header.js based on scroll position),
			// make its text follow whichever slide is active instead of the fixed
			// Background 2 scheme. Scoped to that one class combo so the header's
			// normal (scrolled/solid) state is untouched.
			const syncHeaderColors = (swiper) => {
				const header = document.querySelector('.shopify-section-header');
				if (!header) return;

				const activeSlide = swiper.slides[swiper.activeIndex];
				if (!activeSlide) return;

				const slideStyle = getComputedStyle(activeSlide);
				const varsToSync = [
					'--color-foreground',
					'--color-foreground-secondary',
					'--color-foreground-title',
					'--color-background',
				];

				let styleTag = document.getElementById('slideshow-header-color-sync');
				if (!styleTag) {
					styleTag = document.createElement('style');
					styleTag.id = 'slideshow-header-color-sync';
					document.head.appendChild(styleTag);
				}

				const declarations = varsToSync
					.map((name) => `${name}: ${slideStyle.getPropertyValue(name).trim()};`)
					.join(' ');

				// Pick the logo variant to match: a light (white-ish) foreground means
				// the slide has a dark background, so show the light "logo_2" upload;
				// a dark foreground means a light background, so show the normal logo.
				const [r, g, b] = slideStyle
					.getPropertyValue('--color-foreground')
					.split(',')
					.map((n) => parseFloat(n));
				const isLightForeground = r != null && (0.299 * r + 0.587 * g + 0.114 * b) > 128;

				const logoRule = isLightForeground
					? `.shopify-section-header.color-background-2 .header__heading-logo:not(.header__heading-logo--overlay) { display: none !important; }
					   .shopify-section-header.color-background-2 .header__heading-logo--overlay { display: block !important; }`
					: `.shopify-section-header.color-background-2 .header__heading-logo:not(.header__heading-logo--overlay) { display: block !important; }
					   .shopify-section-header.color-background-2 .header__heading-logo--overlay { display: none !important; }`;

				styleTag.textContent = `.shopify-section-header.color-background-2 { ${declarations} } ${logoRule}`;
			};

			const swiperImg = new Swiper(swiperImgSelector, {
					pagination: {
						el: `#${id} .swiper-pagination`,
						clickable: true,
					},
					...swiperParams,
					...autoplayParams,
					effect: effect,
					thumbs: {
						swiper: swiperText,
					},
				on: {
					init: function () {
						swiperImgElement.classList.add('first_step');
						box.style.setProperty('--bullet-duration', `${delay}ms`);
						syncTabColors(this);
						syncHeaderColors(this);
					},
					slideChange: function () {
						box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
						syncTabColors(this);
						syncHeaderColors(this);
					},
					slideChangeTransitionEnd: function () {
						swiperImgElement.classList.remove('first_step');
					}
				}
			});

			if (autoplay && stopAutoplay) {
				swiperImgElement.addEventListener("mouseenter", function () {
						swiperTextElement.classList.add("stop_move");
					});
					swiperImgElement.addEventListener("mouseleave", function () {
						swiperTextElement.classList.remove("stop_move");
					});
			}

			if($(block.find(".slideshow__content")).length === 1) {
				swiperImgElement.classList.add('no_slideshow');
				swiperTextElement.classList.add('no_slideshow');

				swiperImg.destroy(true, true);
				swiperText.destroy(true, true);
			}
		})
	}


	const initSoundButtons = (root) => {
		(root || document).querySelectorAll('.js-sound-video').forEach((btn) => {
			if (btn._soundInit) return;
			btn._soundInit = true;
			btn.addEventListener('click', () => {
				let parent = btn.parentElement;
				while (parent) {
					if (parent.querySelector('video, iframe')) break;
					parent = parent.parentElement;
				}
				if (!parent) return;
				const video = parent.querySelector('video');
				if (video) {
					setTimeout(() => { video.muted = !video.muted; }, 10);
					btn.classList.toggle('active');
				}
				const iframe = parent.querySelector('iframe');
				if (iframe) {
					if (iframe.classList.contains('video-muted')) {
						if (iframe.classList.contains('js-youtube')) {
							iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
						} else if (iframe.classList.contains('js-vimeo')) {
							iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
						}
						iframe.classList.remove('video-muted');
					} else {
						if (iframe.classList.contains('js-youtube')) {
							iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
						} else if (iframe.classList.contains('js-vimeo')) {
							iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
						}
						iframe.classList.add('video-muted');
					}
					btn.classList.toggle('active');
				}
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		initSoundButtons(document);
		document.addEventListener("shopify:section:load", function (e) {
			slideshow();
			initSoundButtons(e.target);
		});
	});
})();

// test